import { Controller } from "@hotwired/stimulus"
import { scaleAndFormat } from "../utils/recipe_math"

// Recipe Scaler (Phase 1 item 1.3).
//
// Mounted on the ingredients <aside>. The stepper bumps a target servings
// value up or down; on every change we walk every `data-recipe-scaler-target="amount"`
// span and rewrite its text using recipe_math.
//
// Each amount span carries:
//   data-original-amount="200"   ← canonical numeric amount from the YAML
//   data-unit="g"                 ← unit string so the scaler picks the right
//                                   rounding rule
//
// Target servings stays in the DOM at `servings` for both display and for
// the shopping-list form to read on submit.
export default class extends Controller {
  static targets = [ "servings", "amount", "decrement", "increment" ]
  static values = {
    originalServings: { type: Number, default: 1 },
    minServings:      { type: Number, default: 1 },
    maxServings:      { type: Number, default: 24 }
  }

  connect() {
    this._target = this.originalServingsValue
    this._render()
  }

  increment() {
    if (this._target >= this.maxServingsValue) return
    this._target += 1
    this._render()
  }

  decrement() {
    if (this._target <= this.minServingsValue) return
    this._target -= 1
    this._render()
  }

  // Read the current target so the shopping-list controller can submit it.
  currentServings() {
    return this._target
  }

  _render() {
    if (this.hasServingsTarget) {
      this.servingsTarget.textContent = this._target.toString()
    }
    this._updateButtonStates()

    this.amountTargets.forEach((el) => {
      const original = parseFloat(el.dataset.originalAmount)
      if (isNaN(original)) return
      const unit = el.dataset.unit || ""
      const formatted = scaleAndFormat(original, unit, this.originalServingsValue, this._target)
      el.textContent = unit ? `${formatted} ${unit}` : formatted
    })

    // Tell the shopping-list form (if mounted next to us) the new value
    // so its hidden field stays in sync — uses a CustomEvent so the two
    // controllers don't need a Stimulus outlet wiring.
    this.element.dispatchEvent(new CustomEvent("recipe-scaler:change", {
      bubbles: true,
      detail: { servings: this._target }
    }))
  }

  _updateButtonStates() {
    if (this.hasDecrementTarget) {
      this.decrementTarget.disabled = this._target <= this.minServingsValue
    }
    if (this.hasIncrementTarget) {
      this.incrementTarget.disabled = this._target >= this.maxServingsValue
    }
  }
}
